var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 401,
    height: 217,
    viewBox: "0 0 401 217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1036",
    "data-name": "Rectangle 1036",
    width: 325.159,
    height: 209,
    fill: "#0f5ee9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3447",
    "data-name": "Groupe 3447",
    transform: "translate(-837 -336)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 200.5,
    cy: 8.5,
    rx: 200.5,
    ry: 8.5,
    transform: "translate(837 536)",
    fill: "#a4c7f6",
    opacity: 0.413
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3444",
    "data-name": "Groupe 3444",
    transform: "translate(871.42 336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3440",
    "data-name": "Groupe 3440",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2730",
    "data-name": "Trac\\xE9 2730",
    d: "M174.444,20.656l-2.581-7.313A20,20,0,0,0,153,0H67.154a20,20,0,0,0-20,20V189a20,20,0,0,0,20,20h238a20,20,0,0,0,20-20V54a20,20,0,0,0-20-20H193.3a20,20,0,0,1-18.86-13.344",
    fill: "#0f5ee9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2733",
    "data-name": "Trac\\xE9 2733",
    d: "M325.159,185.73V189a20,20,0,0,1-20,20H63.909c-11.05,0-21.88-8.05-24.19-17.99L4.319,38.99C2,29.05,9.079,21,20.129,21h85.85a26.38,26.38,0,0,1,21.65,12l4.12,6.58a26.38,26.38,0,0,0,21.65,12h111.85c11.05,0,21.88,8.06,24.19,17.99l27.31,117.27a4.28,4.28,0,0,0,8.41-1.11",
    fill: "#a4c7f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2734",
    "data-name": "Trac\\xE9 2734",
    d: "M149.885,155.037l-14.276-11.314,36.538-49.5,14.276,11.314Z",
    fill: "#0f5ee9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2735",
    "data-name": "Trac\\xE9 2735",
    d: "M125.612,105.54l8.352-11.314,62.457,49.5-8.352,11.313Z",
    fill: "#0f5ee9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderEmpty);
export default __webpack_public_path__ + "static/media/folder-empty.b619f0c6.svg";
export { ForwardRef as ReactComponent };